import React, { useEffect } from "react";
import { Link, useHistory, useLocation } from 'react-router-dom';
import { AdsGETApiAuth, AdsPOSTApi, AdsPUTApi } from "../../../../Constant/api";
import { slugs } from "../../../../Constant/slugs";
import { AlertComponent } from "../../../AlertComponent";
import { CustomButton } from "../../../CustomButtom";
import FileUpload from "../../../FileUpload";
import ImageUpload from "../../../ImageUpload";
import { CustomButtonUnSelect } from "../../../CustomButtomUnselect";
import Alltopics from "../../../../Constant/alltopics.json";

export default function FormComponent(props) {
  const { FetchData } = props;
  const history = useHistory()
  const [ID, setID] = React.useState(FetchData.id)

  const [Title, setTitle] = React.useState(FetchData.title.rendered)
  const [CourseName, setCourseName] = React.useState(FetchData.meta.course_name)
  const [BatchName, setBatchName] = React.useState(FetchData.meta.batch_name)
  const [Duration, setDuration] = React.useState(FetchData.meta.duration)
  const [FeeType, setFeeType] = React.useState(FetchData.meta.fee_type)
  const [BatchType, setBatchType] = React.useState(FetchData.meta.batch_type)
  const [BatchStartDate, setBatchStartDate] = React.useState(FetchData.meta.start_date)
  const [BatchEndDate, setBatchEndDate] = React.useState(FetchData.meta.end_date)
  const [Teachers, setTeachers] = React.useState(FetchData.meta.teachers == "" ? [] : JSON.parse(FetchData.meta.teachers))
  const [Capacity, setCapacity] = React.useState(FetchData.meta.capacity)
  const [IsActive, setIsActive] = React.useState(FetchData.meta.is_active)
  const [SessionName, setSessionName] = React.useState(FetchData.meta.session_name)
  const [PreFix, setPreFix] = React.useState(FetchData.meta.prefix)

  const [TeachersList, setTeachersList] = React.useState([])

  const [reload, setReload] = React.useState(false)

  const [AlertShow, setAlertShow] = React.useState(false)
  const [Alertcomp, setAlertcomp] = React.useState("")

  const uniqueSubjects = Alltopics.filter((item, index, self) =>
    index === self.findIndex((t) => t.subject === item.subject)
  );

  const [firstSelection, setFirstSelection] = React.useState("");
  const [secondSelection, setSecondSelection] = React.useState("");
  const [thirdSelection, setThirdSelection] = React.useState("");


  const EditInfo = () => {
    setReload(true)
    const data = {
      "title": Title,
      "status": "publish",
      "meta": {
        "course_name": `${CourseName}`,
        "batch_name": `${BatchName}`,
        "duration": `${Duration}`,
        "fee_type": `${FeeType}`,
        "start_date": `${BatchStartDate}`,
        "end_date": `${BatchEndDate}`,
        "teachers": JSON.stringify(Teachers),
        "capacity": `${Capacity}`,
        "is_active": `${IsActive}`,
        "session_name": `${SessionName}`,
        "batch_type": `${BatchType}`,
        "prefix": `${PreFix}`
      }
    }

    if (ID === "")
      AdsPOSTApi(data, slugs.db_slug_batches)
        .then((res) => {
          setReload(false)
          setID(res.data.id)
          setAlertShow(true)
          setAlertcomp("Batch Added Successfully")
          history.push(`${slugs.batches_details}${res.data.slug}`)
        }).catch(err => {
          setReload(false)
          console.log(err)
          setAlertShow(true)
          setAlertcomp(err.response.data.message)
        })
    else
      AdsPUTApi(data, slugs.db_slug_batches, ID)
        .then((res) => {
          setReload(false)
          setAlertShow(true)
          setAlertcomp(`${Title} edited Successfully`)
        }).catch(err => {
          console.log(err)
          console.warn(err.response.data)
          console.log("Response Status: hello11", err.response.status);
          console.log("Response Headers:", err.response.headers);
          setReload(false)
          setAlertShow(true)
          setAlertcomp(err.response.data.message)
        })
  }

  useEffect(() => {
    TeachersListFetch()
  }, [])

  const TeachersListFetch = () => {
    AdsGETApiAuth({
      per_page: 100,
      _fields: "id,slug,meta,title"
    }, slugs.db_slug_teachers)
      .then(res => {
        setTeachersList(res.data)
      })
  }

  return (
    <div>
      <div className="row">
        <div className="col-sm-2 col-1"></div>
        <div className="col-sm-8 col-10 form-view mb-3">
          <h4><center>Batch Information</center></h4>
          <table>
            <tbody>
              <tr>
                <td className="col-3">Batch Name</td>
                <td className="col-6">
                  <input className="input-common"
                    value={BatchName} placeholder="Batch Name eg. Nasu 3rd Paper Q/A Class (Physical Class)"
                    onChange={(event) => { setBatchName(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Course Name</td>
                <td className="col-6">
                  <input className="input-common"
                    value={CourseName} placeholder="Course Name eg. Nasu preparation"
                    onChange={(event) => { setCourseName(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Session</td>
                <td className="col-6">
                  <input className="input-common"
                    value={SessionName} placeholder="Session eg 83/84"
                    onChange={(event) => { setSessionName(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Batch Type</td>
                <td className="col-6">
                  <CustomButton setData={setBatchType} Data={BatchType} DataValue={"Online"} />
                  <CustomButton setData={setBatchType} Data={BatchType} DataValue={"Physical"} />
                  <CustomButton setData={setBatchType} Data={BatchType} DataValue={"Both"} />
                  {/* <input className="input-common"
                    value={Title} placeholder="Name"
                    onChange={(event) => { setTitle(event.target.value) }}
                  /> */}
                </td>
              </tr>
              <tr>
                <td className="col-3">Duration</td>
                <td className="col-6">
                  <input className="input-common"
                    value={Duration} placeholder="Duration eg. 3 month, 6 month"
                    onChange={(event) => { setDuration(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Fee Type</td>
                <td className="col-6">
                  <CustomButton setData={setFeeType} Data={FeeType} DataValue={"Installment"} />
                  <CustomButton setData={setFeeType} Data={FeeType} DataValue={"Monthly"} />
                  {/* <input className="input-common"
                    value={Title} placeholder="Name"
                    onChange={(event) => { setTitle(event.target.value) }}
                  /> */}
                </td>
              </tr>
              <tr>
                <td className="col-3">Roll No Prefix</td>
                <td className="col-6">
                  <input className="input-common"
                    value={PreFix} placeholder="Prefix"
                    onChange={(event) => { setPreFix(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Start Date</td>
                <td className="col-6">
                  <input className="input-common"
                    value={BatchStartDate} placeholder="Start Date" type="date"
                    onChange={(event) => { setBatchStartDate(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">End Date</td>
                <td className="col-6">
                  <input className="input-common"
                    value={BatchEndDate} placeholder="End Date" type="date"
                    onChange={(event) => { setBatchEndDate(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Capacity</td>
                <td className="col-6">
                  <input className="input-common"
                    value={Capacity} placeholder="Capacity eg 40"
                    onChange={(event) => { setTitle(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Teachers</td>
                <td className="col-6">
                  {/* <input className="input-common"
                    value={Capacity} placeholder="Capacity eg 40"
                    onChange={(event) => { setTitle(event.target.value) }}
                  /> */}
                  {Object.values(Teachers).map((item, index) => (
                    <div>
                      {item}
                    </div>
                  ))}
                </td>
              </tr>
              <tr>
                <td className="col-3">is Active</td>
                <td className="col-6">
                  <CustomButton setData={setIsActive} Data={IsActive} DataValue={"Starting Soon"} />
                  <CustomButton setData={setIsActive} Data={IsActive} DataValue={"Active"} />
                  <CustomButton setData={setIsActive} Data={IsActive} DataValue={"Completed"} />
                </td>
              </tr>
            </tbody>
          </table>
          <div className="row center m-2">
            <div className=" col-3" style={{ padding: "0 10px" }}>
              <div className="sign-in-button-4"
                onClick={() => {
                  EditInfo()
                }}
              >
                Update Batch
              </div>
            </div>
          </div>
        </div>
      </div >

      {reload &&
        <div className="modal" style={{ padding: "50vw" }}>
          <div className="dot-pulse"></div>
        </div>
      }
      {
        AlertShow &&
        <AlertComponent Alertcomp={Alertcomp} setAlertShow={setAlertShow} />
      }

      {/* {JSON.stringify(uniqueSubjects)} */}
      <div className="selector-group">
        <label htmlFor="faculty">Step 1: Select Faculty</label>

        <select
          id="faculty"
          value={firstSelection}
          onChange={() => {
            setFirstSelection("")
          }}

        >
          <option value="">Choose faculty</option>

          {uniqueSubjects.map((item, index) => (
            <option key={index} value={item.subject}>
              {item.subject}
            </option>
          ))}
        </select>
      </div>

    </div >
  )

}